<template>
  <div class="tw-w-screen tw-px-4 tw-py-10">
    <div
      class="tab-view-container tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="title tw-w-full tw-text-center tw-text-textMain"
        v-html="$t('首页小标题')"
      ></span>
      <div class="tw-flex tw-flex-col tw-w-full">
        <div class="tw-flex tw-w-full tw-justify-center">
          <!-- Tab 背景容器 -->
          <ul 
            class="tw-list-none tw-flex tw-items-center tab-scroll"
            style="
              height: 48px;
              background: #F4F4F4;
              border-radius: 100px;
              padding: 4px;
              width: 100%;
              margin: 16px 0 20px;
              overflow-x: auto;
              white-space: nowrap;
              gap: 8px;
            "
          >
            <li
              v-for="item in tabsList"
              :key="item.categoryId"
              class="tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all"
              @click="handleTabClick(item)"
            >
              <div
                class="tw-flex tw-items-center tw-justify-center tw-transition-all"
                :class="{
                  'tab-item-active': item.categoryId == activeTabId,
                }"
                :style="{
                  height: item.categoryId == activeTabId ? '40px' : 'auto',
                  padding: '0 16px',
                  background: item.categoryId == activeTabId ? '#FFFFFF' : 'transparent',
                  borderRadius: '100px',
                  fontWeight: 600,
                  fontSize: '14px',
                  color: item.categoryId == activeTabId ? '#111111' : '#666666'
                }"
              >
                <span>{{ translateText(item.categoryName) }}</span>
              </div>
            </li>
          </ul>
        </div>
        <!-- 卡片网格布局 -->
        <div class="product-grid">
          <div
            v-for="(item, index) in swiperList"
            :key="item.id || index"
            class="product-card-wrapper"
          >
            <div
              class="product-card tw-cursor-pointer tw-transition-all hover:tw-shadow-lg"
              :style="{ backgroundImage: `url(${item.pic})` }"
              @click="handleCardClick(item)"
            >
              <h3 class="product-title">{{ item.name }}</h3>
            </div>
          </div>
        </div>
        <div class="tw-mt-2 tw-mb-6 tw-text-center" style="font-size: 14px;
color: #999999;">
          {{ $t("找不到合适的产品或方案？") }}
          <span
            style="color: #4077F8FF; cursor: pointer;"
            @click="handleConsultClick"
          >
            <span>{{ $t("查看更多") }}</span>
            <b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import referrerImg from "@/assets/home/referrer-icon.png";
import { productsApi } from "@/api/modules/home";
export default {
  data() {
    return {
      referrerImg,
      tabsList: [],
      isVisible: false,
      observer: null,
      activeTabId: 1,
      hoverId: -1,
    };
  },
  computed: {
    swiperList() {
      if (!this.tabsList || this.tabsList.length <= 0) {
        return [];
      }

      let item = this.tabsList.find(
        (item) => item.categoryId == this.activeTabId,
      );

      if (!item || !item.products || !Array.isArray(item.products)) {
        return [];
      }

      if (item.products.length > 6) {
        return item.products.slice(0, 6);
      }
      return item.products;
    },
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem("indexInfo"));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleToMore() {
      this.$router.push({
        path: "/product",
      });
    },

    handleHover(hover, id) {
      this.hoverId = hover ? id : -1;
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
          rootMargin: "0px 0px -50px 0px", // 提前50px触发
        },
      );

      this.observer.observe(this.$el);
    },
    getList() {
      let info = JSON.parse(localStorage.getItem("indexInfo"));
      this.tabsList = this.normalizeHomeProductTabs(
        info.recommendProductList.slice(0, 3),
      );

      // 添加"精选推荐"分类
      this.tabsList.unshift({
        categoryId: -1,
        categoryName: this.$t("精选推荐"),
        products: [], // 初始为空，稍后通过API获取
      });

      // 添加"公链生态"分类
      this.tabsList.push({
        categoryId: 69,
        categoryName: this.$t("公链生态"),
        products: [], // 初始为空，稍后通过API获取
      });

      if (this.tabsList.length > 0) {
        this.activeTabId = this.tabsList[0].categoryId;
        if (this.activeTabId === -1) {
          this.fetchRecommendProducts();
        }
      }
    },

    async fetchRecommendProducts() {
      try {
        const res = await productsApi({
          pageIndex: 1,
          pageSize: 6,
          isRecommend: 1,
        });

        if (res && res.data && res.data.list) {
          const recommendTab = this.tabsList.find(
            (item) => item.categoryId === -1,
          );
          if (recommendTab) {
            this.$set(recommendTab, "products", res.data.list.slice(0, 6));
          }
        }
      } catch (error) {
        console.error("获取推荐产品失败:", error);
      }
    },

    async fetchPublicChainProducts() {
      try {
        const res = await productsApi({
          pageIndex: 1,
          pageSize: 6,
          categoryId: 69,
          sortField: "id",
          sortOrder: "asc",
        });

        if (res && res.data && res.data.list) {
          const publicChainTab = this.tabsList.find(
            (item) => item.categoryId === 69,
          );
          if (publicChainTab) {
            this.$set(
              publicChainTab,
              "products",
              this.sortProductsById(res.data.list).slice(0, 6),
            );
          }
        }
      } catch (error) {
        console.error("获取公链生态产品失败:", error);
      }
    },
    sortProductsById(products = []) {
      if (!Array.isArray(products)) {
        return [];
      }
      // 首页产品模块要求老产品优先，统一按产品 ID 从小到大展示。
      return [...products].sort((a, b) => Number(a.id || 0) - Number(b.id || 0));
    },
    normalizeHomeProductTabs(tabs = []) {
      if (!Array.isArray(tabs)) {
        return [];
      }
      return tabs.map((item) => ({
        ...item,
        products: this.sortProductsById(item.products),
      }));
    },
    translateText(text) {
      if (!text) {
        return "";
      }
      return this.$te(text) ? this.$t(text) : text;
    },
    handleClickRoute(row) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/product/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/product",
        });
      }
    },
    handleTabClick(item) {
      this.activeTabId = item.categoryId;
      // 如果点击的是推荐产品(-1)，并且还没有加载过数据，则请求数据
      if (
        item.categoryId === -1 &&
        (!item.products || item.products.length === 0)
      ) {
        this.fetchRecommendProducts();
      }
      // 如果点击的是公链生态(69)，并且还没有加载过数据，则请求数据
      if (
        item.categoryId === 69 &&
        (!item.products || item.products.length === 0)
      ) {
        this.fetchPublicChainProducts();
      }
    },
    handleCardClick(row) {
      console.log(11111, row);
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/product/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/product",
        });
      }
    },
    handleConsultClick() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // if (row.id) {
      //   localStorage.setItem("detailForm", JSON.stringify(row));
      //   this.$router.push({
      //     path: "/solution/" + row.id + "?isApi=false",
      //   });
      // } else {
        this.$router.push({
          path: "/product",
        });
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-scroll {
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
  .title {
    font-weight: 600;
    font-size: 20px;
    color: #111111;
  }
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 20px 0;
}

.product-card-wrapper {
  display: flex;
  justify-content: center;
}

.product-card {
  width: 100%;
  max-width: 335px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 0px 30px 0px rgba(48, 66, 137, 0.05);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  aspect-ratio: 162 / 192;
  
  &:hover {
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
  }
}

.product-title {
  font-weight: 600;
  font-size: 14px;
  color: #111111;
  padding: 20px 20px 0 20px;
  text-align: left;
  
  @media (min-width: 1280px) {
    font-size: 20px;
  }
  
  @media (min-width: 1536px) {
    font-size: 24px;
  }
}
</style>
